<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Customer Admin</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
				
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-overlay :show="this.working" rounded="sm">
			<div class="row">
				<div class="col-md-3">
					<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
					<div class="leftSide">
						<b-table :filter="search" striped hover small :items="customers" selectable select-mode="single" :fields="['customers', 'linked']" @row-clicked="onCustomerSelected"></b-table>					
					</div>
				</div>
				<div class="col-md-8 m-3 mt-0" v-if="customer">
					<div class="row mb-2">
						<h4>{{customer.id}}</h4>
					</div>
					<div class="row mb-2">
						<div class="col-md-4">
							Title: <b-form-input readonly class="mb-2" v-model="customer.person.title"></b-form-input>
						</div>
						<div class="col-md-4">
							First Name: <b-form-input readonly class="mb-2" v-model="customer.person.firstName"></b-form-input>
						</div>
						<div class="col-md-4">
							Last Name: <b-form-input readonly class="mb-2" v-model="customer.person.lastName"></b-form-input>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-md-4">
							Email: <b-form-input readonly class="mb-2" v-model="customer.person.email"></b-form-input>
						</div>
						<div class="col-md-4">
							Mobile: <b-form-input readonly class="mb-2" v-model="customer.person.mobilePhone"></b-form-input>
						</div>
						<div class="col-md-4">
							DOB: <b-form-input readonly class="mb-2" v-model="customer.person.dob"></b-form-input>
						</div>
					</div>
					<div class="row mb-2" v-if="customer.employerID">
						<div class="col-md-4">
							Employer: <b-form-input readonly class="mb-2" v-model="customer.employer.name"></b-form-input>
						</div>
						<div class="col-md-4">
							<br/>
							<b-button size="sm" v-b-modal.modal-emp>Link Employer</b-button>
							<b-modal id="modal-emp" title="Select Employer">
								<b-form-input placeholder="search" class="mb-2" v-model="employerSearch"></b-form-input>
								<b-table :filter="search" striped hover small :items="employers" selectable :fields="['name']" @row-clicked="selectEmployer"></b-table>
							</b-modal>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-md-12">
							Signed Up: {{customer.createDateTime}}<br/>
							Last Logged In: {{customer.lastLoginDateTime}}<br/>
							<b-button 
								variant="primary" 
								class="mt-2"
								@click="showCreditModal = true"
							>
								Manage Credit
							</b-button>
						</div>
					</div>
					<b-alert class="mt-3" show variant="danger">
						<strong>I have obtained explicit permission from the customer to view their details.</strong> <br/>
						<small>Section 170 of the Data Protection Act 2018 (DPA 2018) makes it a criminal offense to unlawfully obtain personal data.</small>
						<b-form-checkbox class="mb-2" v-model="permission"></b-form-checkbox>
					</b-alert>
					<div v-if="permission">
						<div class="row mb-2" v-if="insurance && insurance.length > 0">
							<div class="col-md-12">
								Insurance: {{insurance.length}}<br/><br/>
								<b-table striped hover small :items="insurance" :fields="[{key:'provider.name', label:'Provider'}, {key:'policyType.name', label:'Type'}, 'policyNumber', {key:'insuredItems[0].vehicleRegistration', label:'Reg'}, {label: 'Details', key:'showDetails', sortable:false}]">
									<template #cell(showDetails)="row">
										<b-button size="sm" variant="link" @click="row.toggleDetails" class="mr-2">
											<b-icon icon="three-dots" />
										</b-button>
									</template>
									<template #row-details="row">
										<b-card>
											<b-row>
												<div class="col-md-4">
													Policy Number: <b-form-input class="mb-2" v-model="row.item.policyNumber"></b-form-input>
												</div>
												<div class="col-md-4">
													Reg: <b-form-input class="mb-2" v-model="row.item.insuredItems[0].vehicleRegistration"></b-form-input>
												</div>
												<div class="col-md-4">
													Premium (£): <b-form-input class="mb-2" v-model="row.item.annualPremium"></b-form-input>
												</div>
											</b-row>
											<b-row>
												<div class="col-md-4">
													Provider:
													<b-form-input class="mb-2" v-model="row.item.provider.name" placeholder="Enter Provider" required></b-form-input>
												</div>
												<div class="col-md-4">
													Excess (£):
													<b-form-input type="number" class="mb-2" v-model="row.item.excess" placeholder="Enter Excess" required></b-form-input>
												</div>
												<div class="col-md-4">
													No Claims Years:
													<b-form-input type="number" class="mb-2" v-model="row.item.noClaimsYears" placeholder="Enter No Claims Years"></b-form-input>
												</div>
											</b-row>
											<b-row>
												<div class="col-md-4">
													Start Date:
													<b-form-input class="mb-2" v-model="row.item.startDateString" required></b-form-input>
												</div>

													<!-- End Date -->
													<div class="col-md-4">
													End Date:
													<b-form-input class="mb-2" v-model="row.item.endDateString" required></b-form-input>
												</div>
											</b-row>
											<b-row class="mt-3">
												<b-col>
													<p>AIOP Object:</p>
													<code>
														{{ row.item }}
													</code>
												</b-col>
											</b-row>
										</b-card>
									</template>
								</b-table>
							</div>
						</div>
						<div class="row mb-2" v-if="investments && investments.length > 0">
							<div class="col-md-12">
								Investments: {{investments.length}}<br/><br/>
								<b-table striped hover small :items="investments" :fields="[{key:'provider.name', label:'Provider'}, {key:'accountType.name', label:'Type'}, 'accountNumber', {label: 'Details', key:'showDetails', sortable:false}]">
									<template #cell(showDetails)="row">
										<b-button size="sm" variant="link" @click="row.toggleDetails" class="mr-2">
											<b-icon icon="three-dots" />
										</b-button>
									</template>
									<template #row-details="row">
										<b-card>
											<b-row>
												<div class="col-md-4">
												Account Number: <b-form-input class="mb-2" v-model="row.item.accountNumber"></b-form-input>
												</div>
												<div class="col-md-4">
												Account Type: <b-form-input class="mb-2" v-model="row.item.accountType.name"></b-form-input>
												</div>
												<div class="col-md-4">
												Provider: <b-form-input class="mb-2" v-model="row.item.provider.name"></b-form-input>
												</div>
											</b-row>
											<b-row>
												<div class="col-md-4">
												Balance: <b-form-input class="mb-2" type="number" step="0.01" v-model="row.item.balance"></b-form-input>
												</div>
												<div class="col-md-4">
												Allowance Used: <b-form-input class="mb-2" type="number" step="0.01" v-model="row.item.taxYearAllowanceUsed"></b-form-input>
												</div>
												<div class="col-md-4">
												Personal Contribution: <b-form-input class="mb-2" type="number" step="0.01" v-model="row.item.personalMonthlyContribution"></b-form-input>
												</div>
											</b-row>
											<b-row>
												<div class="col-md-4">
												Employer Contribution: <b-form-input class="mb-2" type="number" step="0.01" v-model="row.item.employerMonthlyContribution"></b-form-input>
												</div>
												<div class="col-md-4">
												Retirement Age: <b-form-input class="mb-2" type="number" v-model="row.item.retirementAge"></b-form-input>
												</div>
											</b-row>
											<b-row class="mt-3">
												<b-col>
													<p>AIOP Object:</p>
													<code>
														{{ row.item }}
													</code>
												</b-col>
											</b-row>
										</b-card>
									</template>
								</b-table>
							</div>
						</div>
						<div class="row mb-2" v-if="completedMoves && completedMoves.length > 0">
							<div class="col-md-12">
								Completed moves: {{completedMoves.length}}<br/><br/>
								<b-table striped hover small :items="completedMoves" :fields="['completedMoves', 'description']"></b-table>
							</div>
						</div>
						<div class="row mb-2" v-if="moves && moves.length > 0">
							<div class="col-md-12">
								Pending moves: {{moves.length}}<br/><br/>
								<b-table striped hover small :items="moves" :fields="['pendingMoves', 'description']"></b-table>
							</div>
						</div>
						<br/>
						<div class="row mb-2" v-if="customer.facts">
							<h4>Fact Card</h4>
							<div class="col-md-12">
								<table>
									<tr v-for="(value, name) in customer.facts" :key="name">
										<td>{{ name }}</td><td><b-form-input v-model="customer.facts[name]"></b-form-input></td> 
									</tr>
								</table>
								<b-button v-b-modal.modal-emp @click="postFactCard">Generate Moves</b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-overlay>
	</div>

	<!-- Credit Management Modal -->
	<b-modal
		v-model="showCreditModal"
		title="Manage Customer Credit"
		size="lg"
	>
		<div class="mb-4">
			<h5>Add Credit</h5>
			<b-form>
				<b-row align-v="end">
					<b-col cols="auto">
						<b-form-group label="Amount (£)" class="mb-0">
							<b-form-input
								v-model="newCreditAmount"
								type="number"
								step="0.01"
								min="0"
								required
								placeholder="Enter amount"
							></b-form-input>
						</b-form-group>
					</b-col>
					<b-col cols="auto">
						<b-button @click="addCredit" variant="primary">Add</b-button>
					</b-col>
				</b-row>
			</b-form>
		</div>

		<div>
			<h5>Credit Transaction History</h5>
			<b-table
				:items="creditTransactions"
				:fields="[
					{ key: 'createdDateTime', label: 'Date', sortable: true },
					{ key: 'amount', label: 'Amount (£)', sortable: true }
				]"
				striped
				hover
				small
			>
				<template #cell(createdDateTime)="data">
					{{ formatDate(data.value) }}
				</template>
				<template #cell(amount)="data">
					{{ data.value.toFixed(2) }}
				</template>
			</b-table>
		</div>
	</b-modal>
</div>
</template>
<script>
export default {
  name: 'Stats',
  data() {
	return{
		customers: null,
		employers: null,
		customer: null,
		search:"",
		employerSearch:"",
		selfId: null,
		moves: null,
		completedMoves: null,
		insurance: null,
		working: true,
		permission: false,
		showCreditModal: false,
		newCreditAmount: null,
		creditTransactions: []
	}
  },
  methods: {
	getCustomers: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers")
			.then((result) => {
				this.customers = result.data;
				for (var x = 0; x< this.customers.length; x++)
				{
					this.customers[x].customers = this.customers[x].person.firstName 
						+ " " + this.customers[x].person.lastName
					this.customers[x].linked = this.customers[x].employerID != null;
					this.working = false;
				}
			}
		);
	},
	getEmployers: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Employers")
			.then((result) => {
				this.employers = result.data;
				this.working = false;
			}
		);
	},
	getSelf: function() {
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers/00000000-0000-0000-0000-000000000000")
			.then((result) => {
				this.selfId = result.data.id;
				this.working = false;
			}
		);
	},
	onLoad() {
		this.getSelf();
		this.getCustomers();
		this.getEmployers();
	},
	getInsurance: function(id) {
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers/" + id + "/Policies")
			.then((result) => {
				this.insurance = result.data;
				for(var x = 0; x < this.insurance.length; x++) {
					this.insurance[x].showDetails = true;
				}
				this.working = false;
			}
		);
	},
	getInvestments: function(id) {
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers/" + id + "/InvestmentHubAccounts")
			.then((result) => {
				this.investments = result.data;
				for(var x = 0; x < this.investments.length; x++) {
					this.investments[x].showDetails = true;
				}
				this.working = false;
			}
		);
	},
	getMoves: function(id) {
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers/" + id + "/Moves")
			.then((result) => {
				this.moves = result.data;
				for(var x = 0; x < this.moves.length; x++) { this.moves[x].pendingMoves = this.moves[x].title; }
				this.working = false;
			}
		);
	},
	getCompletedMoves: function(id) {
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers/" + id + "/Moves?filterByActioned=true")
			.then((result) => {
				this.completedMoves = result.data;
				for(var x = 0; x < this.completedMoves.length; x++) { this.completedMoves[x].completedMoves = this.completedMoves[x].title; }
				this.working = false;
			}
		);
	},
	selectCustomer(c){
		this.working = true;
		this.customer = c;
		this.permission = false;
		var getFacts = this.selfId == c.id;
		this.$http.get(this.$config.ApiUri + "/Customers/" + c.id + "?getEmployer=true&getFacts=" + getFacts)
			.then((result) => {
				this.customer = result.data;
				this.getMoves(this.customer.id);
				this.getCompletedMoves(this.customer.id);
				this.getInsurance(c.id);
				this.getInvestments(c.id);
				this.working = false;
			}
		);
	},
	postFactCard: function() {
		this.working = true;
		var facts = new Array();
		for (var key in this.customer.facts) {
			facts.push({ "name": key, "value": this.customer.facts[key] });
		}
		this.$http.post(this.$config.ApiUri + "/Customers/" + this.customer.id + "/FactCard", facts)
			.then(() => {
				this.$http.post(this.$config.ApiUri + "/Moves/GenerationRequests?customerId=" + this.selfId, null)
					.then(() => {
						this.$http.get(this.$config.ApiUri + "/Customers/" + this.selfId + "?getEmployer=true&getFacts=true")
							.then((result) => {
								this.customer = result.data;
								this.$http.get(this.$config.ApiUri + "/Customers/" + this.customer.id + "/Moves")
									.then((result) => {
										this.moves = result.data;
										for(var x = 0; x < this.moves.length; x++) { this.moves[x].pendingMoves = this.moves[x].title; }
										this.working=false;
									}
								)
							}
						)
					}
				)
			}
		)
	},
	selectEmployer(e){
		this.working = true;
		this.employer = e;
		this.$http.post(this.$config.ApiUri + "/Customers/" + this.customer.id + "/LinkToEmployerRequests?employerId=" + e.id, null)
			.then(() => {
				this.$http.get(this.$config.ApiUri + "/Customers/" +  this.customer.id + "?getEmployer=true")
					.then((result) => {
						this.customer = result.data;
						this.working = false;
					}
				)
			}
		)
	},
	onCustomerSelected(record) {
		this.selectCustomer(record);
		this.loadCreditTransactions();
	},
	loadCreditTransactions: async function() {
		if (!this.customer) { return; }
		try {
			const response = await this.$http.get(
				`${this.$config.ApiUri}/Customers/${this.customer.id}/Discounts/CustomerCreditTransactions`
			);
			this.creditTransactions = response.data;
		} catch (error) {
			console.error('Error loading credit transactions:', error);
		}
	},
	addCredit: async function() {
		if (!this.customer || !this.newCreditAmount) return;
		try {
			await this.$http.post(
				`${this.$config.ApiUri}/Discounts/CustomerCreditTransactions`,
				{
					customerID: this.customer.id,
					amount: parseFloat(this.newCreditAmount)
				}
			);
			await this.loadCreditTransactions();
			this.newCreditAmount = null;
		} catch (error) {
			console.error('Error adding credit:', error);
		}
	},
	formatDate(dateString) {
		if (!dateString) return '';
		const date = new Date(dateString);
		return date.toLocaleString();
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>